module.exports = __webpack_public_path__ + "static/media/logo_white.980c0539.png";